import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import GetOffer from './pages/GetOffer';
import CarAppraisal from './pages/CarAppraisal';

// Component to scroll to top on route change
const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

const App: React.FC = () => {
    return (
        <Router>
            <ScrollToTop />
            <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/get-offer" element={<GetOffer />} />
                        <Route path="/car-appraisal" element={<CarAppraisal />} />
                    </Routes>
                </main>
                <Footer />
            </div>
            <Analytics />
        </Router>
    );
};

export default App; 